import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@/components/AuthContext'
import { Layout } from '@/components/Layout'
import { LiveFeed } from './LiveFeed'

export function LiveApp() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<LiveFeed />} />
        </Routes>
      </Layout>
    </AuthProvider>
  )
}
